import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { PassType } from "../IMultiPassRenderer";
/**
 * 常规 Pass 基类
 */
export default class BaseNormalPass {
  constructor() {
    _defineProperty(this, "shaderModuleService", void 0);
    _defineProperty(this, "rendererService", void 0);
    _defineProperty(this, "cameraService", void 0);
    _defineProperty(this, "mapService", void 0);
    _defineProperty(this, "interactionService", void 0);
    _defineProperty(this, "layerService", void 0);
    _defineProperty(this, "config", void 0);
  }
  getName() {
    return '';
  }
  getType() {
    return PassType.Normal;
  }
  init(layer, config) {
    this.config = config;
    this.rendererService = layer.getContainer().rendererService;
    this.cameraService = layer.getContainer().cameraService;
    this.mapService = layer.getContainer().mapService;
    this.interactionService = layer.getContainer().interactionService;
    this.layerService = layer.getContainer().layerService;
    this.shaderModuleService = layer.getContainer().shaderModuleService;
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  render(layer) {
    //
  }
}